import { ReactElement } from 'react';
// PropsTypes
import { SliceRaceBannerView } from '@utmb/types/index';
// Types
import { Slice } from '@utmb/types/slice-handler';
// Utils / Context
import { useRaceTrack } from '@utmb/contexts/RaceTrackContext';
// Color Types
import { BannerDiscover } from '@utmb/features/banner-discover/BannerDiscover';
import { BackgroundColorEnum } from '@utmb/types/enum/BackgroundColorEnum';
import { StyleBannerEnum } from '@utmb/types/enum/StyleBannerEnum';
import { LinkPositionEnum } from '@utmb/types/enum/LinkPositionEnum';

export const RegistrationBanner = (props: Slice<SliceRaceBannerView>): ReactElement => {
    const { isDark } = useRaceTrack();

    return (
        <BannerDiscover
            {...props}
            isDark={isDark}
            mainColor={BackgroundColorEnum.RACE}
            style={StyleBannerEnum.FULL}
            picto={null}
            linkPosition={LinkPositionEnum.BELOW_TEXT}
        />
    );
};
